import {Row,Col} from "react-bootstrap";

export default function PiePagina(){
 const imgurl= process.env.REACT_APP_IMG_URL;
    return (
        <Row className="piepagina color-white">
            <Col sm={12}>
            <div><a href="https://www.inegi.org.mx" target="_blank" rel="noreferrer"><img src={imgurl + "home/logoinegibco.png" } alt="Inegi"/></a></div>
            {/* <div className="margin-left-1">
                <Row className="justContent-center">
                    <Col sm={1} className="col1"><a href="https://www.snieg.mx/" className="apiepagina" target="_blank" rel="noreferrer">SNIEG</a><span className="color-white margin-05">|</span></Col>
                    <Col sm={1} className="col3"><a href="https://ci.inegi.org.mx/" className="apiepagina" target="_blank" rel="noreferrer">Órgano Interno de Control</a><span className="color-white margin-05">|</span></Col>
                    <Col sm={1} className="col4"><a href="https://www.inegi.org.mx/transparencia/" className="apiepagina" target="_blank" rel="noreferrer">Transparencia</a></Col>
                </Row>
            </div> */}
            <div className="margin-top1-2"><a href="mailto:normatecainst@inegi.org.mx " className="aemail" target="_blank" rel="noreferrer">normatecainst@inegi.org.mx</a></div>
            <div>Derechos reservados © INEGI</div>
            </Col>
        </Row>
    )
}